import * as OPERATORS from '../../../../components/widgets/FilterInput/FilterOperatorTypes';

export const boardFilterItems = [
  {
    name: 'Contact',
    i18nGroup: 'CONTACT',
    attributes: [
      {
        key: 'contact_name',
        i18nKey: 'CONTACT_NAME',
      },
      {
        key: 'contact_email',
        i18nKey: 'CONTACT_EMAIL',
      },
      {
        key: 'contact_phone',
        i18nKey: 'CONTACT_PHONE',
      },
    ],
  },
  {
    name: 'Board',
    i18nGroup: 'BOARD',
    attributes: [
      {
        key: 'status_id',
        i18nKey: 'STATUS',
      },
      {
        key: 'state',
        i18nKey: 'STATE',
      },
      {
        key: 'source_of_lead',
        i18nKey: 'SOURCE_OF_LEAD',
      },
    ],
  },
  {
    name: 'Assignment',
    i18nGroup: 'ASSIGNMENT',
    attributes: [
      {
        key: 'assignee_id',
        i18nKey: 'ASSIGNEE',
      },
    ],
  },
  {
    name: 'Labels',
    i18nGroup: 'LABELS',
    attributes: [
      {
        key: 'labels_id',
        i18nKey: 'LABELS',
      },
    ],
  },
  {
    name: 'Date',
    i18nGroup: 'DATE',
    attributes: [
      {
        key: 'created_at',
        i18nKey: 'CREATED_AT',
      },
      {
        key: 'last_activity_by',
        i18nKey: 'LAST_ACTIVITY',
      },
    ],
  },
];

// Flat array for filterTypes (used by the filter component)
export const boardFilterTypes = [
  {
    attributeKey: 'contact_name',
    attributeI18nKey: 'CONTACT_NAME',
    inputType: 'plain_text',
    dataType: 'text',
    filterOperators: OPERATORS.OPERATOR_TYPES_1,
    attributeModel: 'standard',
  },
  {
    attributeKey: 'contact_email',
    attributeI18nKey: 'CONTACT_EMAIL',
    inputType: 'plain_text',
    dataType: 'text',
    filterOperators: OPERATORS.OPERATOR_TYPES_1,
    attributeModel: 'standard',
  },
  {
    attributeKey: 'contact_phone',
    attributeI18nKey: 'CONTACT_PHONE',
    inputType: 'plain_text',
    dataType: 'text',
    filterOperators: OPERATORS.OPERATOR_TYPES_1,
    attributeModel: 'standard',
  },
  {
    attributeKey: 'status_id',
    attributeI18nKey: 'STATUS',
    inputType: 'multi_select',
    dataType: 'number',
    filterOperators: OPERATORS.OPERATOR_TYPES_1,
    attributeModel: 'standard',
  },
  {
    attributeKey: 'state',
    attributeI18nKey: 'STATE',
    inputType: 'multi_select',
    dataType: 'text',
    filterOperators: OPERATORS.OPERATOR_TYPES_1,
    attributeModel: 'standard',
  },
  {
    attributeKey: 'source_of_lead',
    attributeI18nKey: 'SOURCE_OF_LEAD',
    inputType: 'multi_select',
    dataType: 'text',
    filterOperators: OPERATORS.OPERATOR_TYPES_1,
    attributeModel: 'standard',
  },
  {
    attributeKey: 'assignee_id',
    attributeI18nKey: 'ASSIGNEE',
    inputType: 'multi_select',
    dataType: 'number',
    filterOperators: OPERATORS.OPERATOR_TYPES_1,
    attributeModel: 'standard',
  },
  {
    attributeKey: 'labels_id',
    attributeI18nKey: 'LABELS',
    inputType: 'multi_select',
    dataType: 'number',
    filterOperators: OPERATORS.OPERATOR_TYPES_1,
    attributeModel: 'standard',
  },
  {
    attributeKey: 'created_at',
    attributeI18nKey: 'CREATED_AT',
    inputType: 'date',
    dataType: 'date',
    filterOperators: [
      {
        value: 'is_greater_than',
        label: 'Is greater than',
      },
      {
        value: 'is_lesser_than',
        label: 'Is lesser than',
      },
      {
        value: 'between',
        label: 'In between',
      },
      {
        value: 'days_before',
        label: 'Is x days before',
      },
    ],
    attributeModel: 'standard',
  },
  {
    attributeKey: 'last_activity_by',
    attributeI18nKey: 'LAST_ACTIVITY',
    inputType: 'multi_select',
    dataType: 'text',
    filterOperators: OPERATORS.OPERATOR_TYPES_1,
    attributeModel: 'standard',
  },
];

export default boardFilterTypes;
